/// <amd-module name="Tfs/ReduxCommon/Modules/Teams/TeamSelectors" />
import * as Reselect from "Reselect";
import { ITeamAwareState, ITeamState } from "Tfs/ReduxCommon/Modules/Teams/TeamContracts";

export function getTeamState(state: ITeamAwareState): ITeamState {
    return state.teamState;
}

export const getTeams = Reselect.createSelector(
    getTeamState,
    (state: ITeamState) => state.teams
);

export const areTeamsLoading = Reselect.createSelector(
    getTeamState,
    (state: ITeamState) => state.loading
);
